// @ai-generated 2026-08-11T00:00:00Z by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { useAgenticOrchestratorRepository } from '@Hooks/useRepository';
import { EnumWorkflowStoryMode } from '@Model';
import { WorkflowDefinitionsRepository, WorkflowRunsRepository } from '@Repositories/AgenticOrchestrator';
import { useQuery } from '@tanstack/react-query';

/** The plan a definition describes, before anything runs — every step still `Pending`. */
export function useWorkflowDefinitionStory(workflowDefinitionId: string) {
    const workflowDefinitions = useAgenticOrchestratorRepository(WorkflowDefinitionsRepository);

    const { data, isLoading, error } = useQuery({
        queryKey: ['agentic-orchestrator', 'workflow_definitions', workflowDefinitionId, 'story'],
        queryFn: () => workflowDefinitions.getStory(workflowDefinitionId),
        enabled: workflowDefinitionId !== '',
    });

    return { view: data?.data, isLoading, error };
}

/**
 * The same rows for a run, with real per-step status. Polls while the run is unfinished so a live
 * run advances without a websocket.
 */
export function useWorkflowRunStory(workflowRunId: string) {
    const workflowRuns = useAgenticOrchestratorRepository(WorkflowRunsRepository);

    const { data, isLoading, error } = useQuery({
        queryKey: ['agentic-orchestrator', 'workflow_runs', workflowRunId, 'story'],
        queryFn: () => workflowRuns.getStory(workflowRunId),
        enabled: workflowRunId !== '',
        refetchInterval: (query) =>
            query.state.data?.data?.mode === EnumWorkflowStoryMode.Live ? LIVE_POLL_MS : false,
    });

    return { view: data?.data, isLoading, error };
}

const LIVE_POLL_MS = 2000;
